module.exports = __webpack_public_path__ + "static/media/location-picker.44dc2c08.png";